export default {
    rewards: [
        {
            name: '',
            category: '',
            points: '',
            description: '',
            isDonation: '',
            idReward: '',
        }
    ],
    rewardsSettings: {
        companyName: '',
        voucherStyle: '',
        currencyCode: 'USD',
        currencySymbol: 'POINTS',
        currencyPosition: 'Right',
        maximumVoucherValue: '',
        addExpiryInVoucher: true,
        rewardExpiryType: 'Days',
        rewardExpiryValue: '',
        expiryDateFormat: '',
        termsAndCondition: 'I hereby accept the terms and conditions, the revocation of the privacy policy and confirm that all information is correct.',
        rewardTermsNote: 'Note: Your order will be processed during next 24 hours',
        postShipping: true,
        shippingMethodForPost: '',
        successfulPageMessage: 'We have got your order!\n' + 'E-Mail Sent Successfully to %s.',
        orderCancellationMessage: 'Order was canceled or payment failed. Please place your order again from here.',
        senderName: '',
        senderEmail: '',
        buyerEmail: '',
        adminEmail: '',
        description: '',
    },
    categoriesRewards: [ ],
    showPage: {
        triggerOrder: false,
        triggerDescriptionOrder: false,
    },
    selectedRewards: {},
    order: {
        donorFirstName: '',
        donorLastName: '',
        personalMessage: '',
        recipientEmail: '',
    },
}